import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { BeaconsService }  from './beacons.service';

export const Ng1BeaconsModule = angular
    .module('control-room.shared.services.beacons', [])
    .factory('crBeaconsService',downgradeInjectable(BeaconsService));

